import { useEffect, useState } from "react"
import { MdOutlineNotifications, MdNotifications } from "react-icons/md";

import { toast } from "react-toastify";
import { Button, Col, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap"
import { NotificationDetails } from "./notification-details";

import { getNotifications, updateNotifications } from "../../../../../services/manager/admin/settings.service"
import { ICommonTestComponent } from "../../../../../models/ICommonTestComponent";
import { Empty } from "antd";

export interface INotification {
  id: number;
  title: string;
  is_active: boolean;

}

export const Notifications: React.FC<ICommonTestComponent> = ({ testMode = false, jestFunc = () => {} }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [showEditNotification, setShowEditNotification] = useState<boolean>(false);
  const [idNotification, setIdNotification] = useState<number>(0);
  const [notificationsList, setNotificationsList] = useState<INotification[]>([]);

  const handleConfigNotification = (id: number) => {
    setIdNotification(id)
    setShowEditNotification(true)
  }

  const handleChangeStatusNotification = (id: number, status: boolean) => {
    let obj = {
      is_active: !status
    }

    updateNotifications(id, obj).then(() => {
      toast.success("Notificação atualizada com sucesso!")
      getNotificationsList();
    }).catch(() => {
      toast.error("Ocorreu um erro ao atualizar a notificação. Tente novamente.")
    })
  }

  const getNotificationsList = () => {
    setLoading(true)
    getNotifications().then((resp) => {
      setNotificationsList(resp)
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    getNotificationsList();
  }, [])

  if (showEditNotification) {
    return (
      <NotificationDetails id={idNotification} back={setShowEditNotification} />
    )
  }

  if (loading && !testMode) {
    return (
      <div className="loading-container">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  return (
    <Row className="ml-2 mt-3 mr-4">
      <Col md={12} className="mt-3 mb-4">
        <h5 className="text-black mb-4"><b>Configurar notificações</b></h5>
        <p className="font-light text-darker-grey">Configure abaixo os e-mails enviados automaticamente pela DStore.</p>
      </Col>
      <Col xs={12}>
      {!!notificationsList.length ? (
              notificationsList.map((notification: INotification) => (
                <div className="bg-white p-3 mb-2">
                  <Row>
                    <Col xs={8} className="d-flex align-items-center">
                      <div>
                        {
                          notification.is_active ? (
                            <OverlayTrigger
                              placement={'top'}
                              overlay={<Tooltip>Desativar</Tooltip>}
                            >
                              <div>
                                <MdNotifications
                                  onClick={() => handleChangeStatusNotification(notification.id, notification.is_active)}
                                  size="22"
                                  className="ml-4 mr-4 text-darker-grey cursor-pointer"
                                />
                              </div>
                            </OverlayTrigger>
                          ) : (
                            <OverlayTrigger
                              placement={'top'}
                              overlay={<Tooltip>Ativar</Tooltip>}
                            >
                              <div>
                                <MdOutlineNotifications
                                  onClick={() => handleChangeStatusNotification(notification.id, notification.is_active)}
                                  size="22"
                                  className="ml-4 mr-4 text-darker-grey cursor-pointer"
                                />
                              </div>
                            </OverlayTrigger>
                          )
                        }
                      </div>
                      <h6 className="mb-0 mt-0 text-darker-grey">{notification.title}</h6>
                    </Col>
                    <Col xs={4} className="text-end">
                      <Button variant="outline-primary" onClick={() => handleConfigNotification(notification.id)}>Configurar</Button>
                    </Col>
                  </Row>
                </div>
              ))

            ) : (
              <Empty description={false} />
            )}

      </Col>
    </Row>
  )
}